import React from 'react'
import { GuidancePage } from './index'

export default () => <GuidancePage language="en" />
